import { useState } from "react";
import axios from "axios";
import "./checkout.css";

export default function Checkout() {
  const cart = JSON.parse(localStorage.getItem("cart")) || [];

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: ""
  });

  const [error, setError] = useState("");

  const total = cart.reduce(
    (s, i) => s + i.price * i.qty,
    0
  );

  const change = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ VALIDATION + PLACE ORDER
  const placeOrder = async () => {
    // Required field check
    if (
      !form.name ||
      !form.phone ||
      !form.email ||
      !form.address ||
      !form.city ||
      !form.state ||
      !form.pincode
    ) {
      setError("Please fill all required fields");
      return;
    }

    // Phone validation
    if (form.phone.length !== 10) {
      setError("Phone number must be 10 digits");
      return;
    }

    // Email validation
    if (!form.email.includes("@")) {
      setError("Please enter a valid email");
      return;
    }

    if (cart.length === 0) {
      setError("Your cart is empty");
      return;
    }

    setError("");

    try {
      await axios.post("http://localhost:5000/api/orders", {
        items: cart,
        total,
        customer: {
          name: form.name,
          phone: form.phone,
          email: form.email
        },
        address: form,
        paymentMethod: "COD"
      });

      localStorage.removeItem("cart");
      alert("Order placed successfully");
      window.location.href = "/";
    } catch {
      alert("Order failed");
    }
  };

  return (
    <div className="checkout-page">
      <div className="checkout-container">
        
        {/* LEFT */}
        <div className="checkout-left">
          <div className="section">
            <h3>Shipping Details</h3>

            <input
              className="field"
              name="name"
              placeholder="Name *"
              onChange={change}
            />
            <input
              className="field"
              name="phone"
              placeholder="Phone *"
              onChange={change}
            />
            <input
              className="field"
              name="email"
              placeholder="Email *"
              onChange={change}
            />
            <input
              className="field"
              name="address"
              placeholder="Address *"
              onChange={change}
            />

            <div className="row-3">
              <input
                className="field"
                name="city"
                placeholder="City *"
                onChange={change}
              />
              <input
                className="field"
                name="state"
                placeholder="State *"
                onChange={change}
              />
              <input
                className="field"
                name="pincode"
                placeholder="Pincode *"
                onChange={change}
              />
            </div>

            {/* ERROR MESSAGE */}
            {error && (
              <p style={{ color: "red", marginTop: "10px" }}>
                {error}
              </p>
            )}
          </div>
        </div>

        {/* RIGHT */}
        <div className="checkout-right">
          <div className="summary">
            {cart.map((item, i) => (
              <div key={i} className="item">
                <span>{item.title} × {item.qty}</span>
                <span>₹{item.price * item.qty}</span>
              </div>
            ))}

            <div className="total">
              <span>Total</span>
              <span>₹{total}</span>
            </div>

            <button className="pay-btn" onClick={placeOrder}>
              Place Order ₹{total}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
